module.exports = __webpack_public_path__ + "img/survey.b9793ea.svg";